// FD-1296: a <cs-button type="submit"> submits its form by making a native button for the
// moment, clicking it and removing it. Turbo disables the button that submitted while the
// request runs, but that is the throwaway one, so the cs-button stays live and a
// double-click sends the form twice. For a toggle (a vote, Subscribe in the peek footer)
// the second submit takes the first back.
//
// While a form's submission runs, a click on any of its cs-buttons (inside it, or outside
// naming it with `form`) is stopped before it reaches the button, and each says
// aria-disabled. Not `disabled`: disabling the focused button drops keyboard focus to
// <body>, and the peek footer keeps focus on the button just pressed (Turbo's own
// "aria-disabled" submitter mode does the same for this reason). A capture listener on
// the host runs before the button inside its shadow root, so the click never gets there.
// Only buttons this marked are released again.
const marked = new WeakMap()

function stopClick(event) {
  event.preventDefault()
  event.stopImmediatePropagation()
}

function submitButtons(form) {
  const inside = form.querySelectorAll("cs-button[type='submit']")
  const outside = form.id ? document.querySelectorAll(`cs-button[type='submit'][form='${CSS.escape(form.id)}']`) : []
  return [ ...inside, ...outside ]
}

document.addEventListener("turbo:submit-start", (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return
  const buttons = submitButtons(form).filter((button) => !button.disabled && !button.hasAttribute("aria-disabled"))
  buttons.forEach((button) => {
    button.setAttribute("aria-disabled", "true")
    button.addEventListener("click", stopClick, true)
  })
  marked.set(form, buttons)
})

document.addEventListener("turbo:submit-end", (event) => {
  const buttons = marked.get(event.target)
  if (!buttons) return
  buttons.forEach((button) => {
    button.removeAttribute("aria-disabled")
    button.removeEventListener("click", stopClick, true)
  })
  marked.delete(event.target)
})
